export const EAEUCountriesId = [4, 5, 166, 89, 34];
export const directionTypes = [
  {
    id: '0',
    name: 'Импорт'
  },
  {
    id: '1',
    name: 'Экспорт'
  }
];

export const validationKeysBlackList = ['id'];

export const nullableFieldsWhiteList = [
  'safePackageTd',
  'intermediateRoute',
  'identificationTool',
  'route',
  'equipmentDescription',
  'additionalInfo'
];

export enum EventLogStatuses {
  WithoutAct = 'withoutAct',
  Queue = 'queue',
  Work = 'work',
  WithAct = 'withAct',
  WithoutAction = 'withoutAction'
}

export enum DeclarationStatuses {
  Draft = 'draft',
  Rejected = 'rejected',
  Revoked = 'revoked',
  Framed = 'framed',
  Accepted = 'accepted'
}

export enum ImportExportStatuses {
  Draft = 'draft',
  InProgress = 'inProgress',
  Open = 'open',
  Extended = 'extended',
  RemovedControl = 'removedControl',
  Completed = 'completed'
}

export enum Actions {
  Read = 'read',
  Create = 'create',
  Write = 'write',
  Export = 'export',
  Remove = 'remove'
}

export interface PermissionParams {
  action: Actions;
  permissions: Permissions | null;
}

export type Permissions = {
  [key in Actions]: boolean;
};

export type Pagination = {
  offset: number;
  limit: number;
};
